export default "__VITE_ASSET__ZBFIqsiW__"